import React, { useState } from 'react';
import './aluminiumwindow.css';

import {
  FaWarehouse,
  FaShieldAlt,
  FaThermometerHalf,
  FaCompressArrowsAlt,
  FaLayerGroup,
  FaTools
} from 'react-icons/fa';

function RoofAndCeiling() {
  const [activeTab, setActiveTab] = useState('types');
  const [selectedImage, setSelectedImage] = useState(0);

  const images = [
    '/roof 4.webp',
    '/roof 6.jpg',
    '/roof2.jpg',
    '/roof 2.webp',
    '/roof 3.webp',
  ];

  const features = [
    {
      icon: <FaWarehouse />,
      title: 'Durable Roofing Systems',
      description: 'High-strength aluminium roofing designed for long-term structural protection'
    },
    {
      icon: <FaShieldAlt />,
      title: 'Weather Resistance',
      description: 'Excellent resistance against rain, heat, corrosion, and UV exposure'
    },
    {
      icon: <FaThermometerHalf />,
      title: 'Thermal Insulation',
      description: 'Reduces heat penetration and improves indoor comfort'
    },
    {
      icon: <FaCompressArrowsAlt />,
      title: 'Lightweight Structure',
      description: 'Strong yet lightweight aluminium reduces load on the building'
    },
    {
      icon: <FaLayerGroup />,
      title: 'Modern Ceiling Designs',
      description: 'Decorative aluminium ceiling systems for commercial and residential interiors'
    },
    {
      icon: <FaTools />,
      title: 'Easy Installation',
      description: 'Prefabricated systems ensure quick and efficient installation'
    }
  ];

  const systemTypes = [
    { name: 'Clear Polycarbonate roof', image: '/polycabernate.webp' },
    { name: 'Tinted Polycarbonate roof', image: '/polly carbanate.jpg' },
    { name: 'False Ceiling Systems', image: '/false ceiling.jpg' },
    { name: 'Perforated Ceiling Panels', image: '/perforated.jpg' },
  ];

  const specifications = [
    { label: 'Material', value: 'High-Grade Aluminium' },
    { label: 'Roof Thickness', value: '0.7mm – 1.2mm' },
    { label: 'Ceiling Panels', value: 'Plain / Perforated Aluminium' },
    { label: 'Thermal Performance', value: 'Heat Reflective Coating' },
    { label: 'Weather Resistance', value: 'Rust & Corrosion Resistant' },
    { label: 'Fire Safety', value: 'Non-Combustible Material' },
    { label: 'Finish', value: 'Powder Coated / Anodized' },
    { label: 'Warranty', value: '10–20 Years' }
  ];

  return (
    <div className="aluminium-window">

      {/* Hero Section */}
      <section className="aluminium-hero">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">Aluminium Roofing & Ceiling Systems</h1>
            <p className="hero-subtitle">
              Innovative roofing and ceiling solutions engineered for strength,
              durability, and modern architectural appeal.
            </p>
          </div>

          <div className="hero-image">
            <img
              src={images[selectedImage]}
              alt="Roof and Ceiling Systems"
              className="hero-main-image"
            />
            <div className="image-thumbnails">
              {images.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt={`Roof & Ceiling ${index + 1}`}
                  className={`thumbnail ${selectedImage === index ? 'active' : ''}`}
                  onClick={() => setSelectedImage(index)}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="features-section">
        <div className="section-header">
          <h2>Why Choose Our Roofing & Ceiling Systems?</h2>
          <p>Designed for performance, protection, and aesthetics</p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Tabs */}
      <section className="tabs-section">
        <div className="tabs-header">
          <button
            className={`tab-btn ${activeTab === 'types' ? 'active' : ''}`}
            onClick={() => setActiveTab('types')}
          >
            System Types
          </button>

          <button
            className={`tab-btn ${activeTab === 'benefits' ? 'active' : ''}`}
            onClick={() => setActiveTab('benefits')}
          >
            Benefits
          </button>
        </div>

        <div className="tabs-content">

          {activeTab === 'types' && (
            <div className="window-types-grid">
              {systemTypes.map((type, index) => (
                <div key={index} className="window-type-card">
                  <img src={type.image} alt={type.name} />
                  <h4>{type.name}</h4>
                </div>
              ))}
            </div>
          )}

          {activeTab === 'benefits' && (
            <div className="benefits-content">
              <div className="benefit-card">
                <h3>Long Lifespan</h3>
                <p>Aluminium systems offer superior durability with minimal maintenance.</p>
              </div>
              <div className="benefit-card">
                <h3>Energy Efficiency</h3>
                <p>Reflective coatings reduce heat gain and lower cooling costs.</p>
              </div>
              <div className="benefit-card">
                <h3>Modern Appearance</h3>
                <p>Enhances both exterior and interior design aesthetics.</p>
              </div>
              <div className="benefit-card">
                <h3>Fire & Safety</h3>
                <p>Non-combustible aluminium improves overall building safety.</p>
              </div>
            </div>
          )}

        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="cta-content">
          <h2>Protect & Elevate Your Building</h2>
          <p>Get in touch for customized aluminium roofing and ceiling solutions</p>
          <div className="cta-buttons">
            <a href="/contactus">
              <button className="btn-outline">Contact Us</button>
            </a>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="faq-section">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-grid">
          <div className="faq-item">
            <h4>Are aluminium roofs suitable for tropical climates?</h4>
            <p>Yes, aluminium reflects heat and resists corrosion, making it ideal for hot and humid conditions.</p>
          </div>
          <div className="faq-item">
            <h4>Do aluminium ceilings require maintenance?</h4>
            <p>Very minimal maintenance is required; occasional cleaning is sufficient.</p>
          </div>
          <div className="faq-item">
            <h4>Are these systems fire resistant?</h4>
            <p>Yes, aluminium is non-combustible and improves fire safety.</p>
          </div>
          <div className="faq-item">
            <h4>Can designs be customized?</h4>
            <p>Yes, ceiling patterns, finishes, and roofing profiles can be fully customized.</p>
          </div>
        </div>
      </section>

    </div>
  );
}

export default RoofAndCeiling;
